'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ChoiceAction = require('./ChoiceAction');

var _ChoiceAction2 = _interopRequireDefault(_ChoiceAction);

var _ChoiceBranchPrintAction = require('./ChoiceBranchPrintAction');

var _ChoiceBranchPrintAction2 = _interopRequireDefault(_ChoiceBranchPrintAction);

var _ChoiceScoreAction = require('./ChoiceScoreAction');

var _ChoiceScoreAction2 = _interopRequireDefault(_ChoiceScoreAction);

var _ClearTerminalAction = require('./ClearTerminalAction');

var _ClearTerminalAction2 = _interopRequireDefault(_ClearTerminalAction);

var _ClickAction = require('./ClickAction');

var _ClickAction2 = _interopRequireDefault(_ClickAction);

var _CorruptedStreamAction = require('./CorruptedStreamAction');

var _CorruptedStreamAction2 = _interopRequireDefault(_CorruptedStreamAction);

var _DialogueAction = require('./DialogueAction');

var _DialogueAction2 = _interopRequireDefault(_DialogueAction);

var _FadeAction = require('./FadeAction');

var _FadeAction2 = _interopRequireDefault(_FadeAction);

var _GoodEndingAction = require('./GoodEndingAction');

var _GoodEndingAction2 = _interopRequireDefault(_GoodEndingAction);

var _PasswordPromptAction = require('./PasswordPromptAction');

var _PasswordPromptAction2 = _interopRequireDefault(_PasswordPromptAction);

var _PrintAction = require('./PrintAction');

var _PrintAction2 = _interopRequireDefault(_PrintAction);

var _SetVisibilityAction = require('./SetVisibilityAction');

var _SetVisibilityAction2 = _interopRequireDefault(_SetVisibilityAction);

var _ShowTerminalAction = require('./ShowTerminalAction');

var _ShowTerminalAction2 = _interopRequireDefault(_ShowTerminalAction);

var _SoundAction = require('./SoundAction');

var _SoundAction2 = _interopRequireDefault(_SoundAction);

var _SoundToggleAction = require('./SoundToggleAction');

var _SoundToggleAction2 = _interopRequireDefault(_SoundToggleAction);

var _WaitAction = require('./WaitAction');

var _WaitAction2 = _interopRequireDefault(_WaitAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(_ref) {
    var game = _ref.game,
        storyJson = _ref.storyJson;

    _classCallCheck(this, _class);

    this.game = game;
    this.storyJson = storyJson;

    this.nodes = [];
    this.completed = {}; // for fast lookup when checking prereqs
  }

  _createClass(_class, [{
    key: 'loadStory',
    value: function loadStory() {
      this.storyJson.forEach(function (nodeData) {
        var klass = this.getClass(nodeData.type);
        var node = new klass({ game: this.game, data: nodeData });
        this.nodes.push(node);
      }, this);
    }
  }, {
    key: 'enableNodes',
    value: function enableNodes() {
      this.getNewEnabled().forEach(function (node) {
        // TODO: there's a bug where a node can get enabled twice, caused by the
        // previous node completing immediately when it gets enabled. Don't have
        // time to fix it properly now but this conditional prevents it.
        if (!node.enabled) {
          node.onCompleteSignal.addOnce(this.onNodeComplete, this);
          node.onEnable();
        }
      }, this);
    }
  }, {
    key: 'onNodeComplete',
    value: function onNodeComplete(node) {
      this.completed[node.id] = true;

      console.log("enabling nodes");

      this.enableNodes();
    }
  }, {
    key: 'getNewEnabled',
    value: function getNewEnabled() {
      var newEnabled = [];

      this.nodes.forEach(function (node) {
        if (!(node.id in this.completed) && !node.enabled && this.nodeCanEnable(node)) {
          newEnabled.push(node);
        }
      }, this);

      return newEnabled;
    }
  }, {
    key: 'nodeCanEnable',
    value: function nodeCanEnable(node) {
      var canEnable = true;

      node.prereqs.forEach(function (prereq) {
        if (!(prereq in this.completed)) {
          canEnable = false;
        }
      }, this);

      return canEnable;
    }
  }, {
    key: 'getNode',
    value: function getNode(nodeId) {
      var matchNode = undefined;

      this.nodes.forEach(function (node) {
        if (node.id == nodeId) matchNode = node;
      });

      return matchNode;
    }
  }, {
    key: 'getClass',
    value: function getClass(nodeType) {
      switch (nodeType) {
        case "choice":
          return _ChoiceAction2.default;
          break;
        case "choice_branch_print":
          return _ChoiceBranchPrintAction2.default;
          break;
        case "choice_score":
          return _ChoiceScoreAction2.default;
          break;
        case "clear_terminal":
          return _ClearTerminalAction2.default;
          break;
        case "click":
          return _ClickAction2.default;
          break;
        case "corrupted_stream":
          return _CorruptedStreamAction2.default;
          break;
        case "dialogue":
          return _DialogueAction2.default;
          break;
        case "fade":
          return _FadeAction2.default;
          break;
        case "good_ending":
          return _GoodEndingAction2.default;
          break;
        case "password_prompt":
          return _PasswordPromptAction2.default;
          break;
        case "print":
          return _PrintAction2.default;
          break;
        case "set_visibility":
          return _SetVisibilityAction2.default;
          break;
        case "show_terminal":
          return _ShowTerminalAction2.default;
          break;
        case "sound":
          return _SoundAction2.default;
          break;
        case "sound_toggle":
          return _SoundToggleAction2.default;
          break;
        case "wait":
          return _WaitAction2.default;
          break;
        case "zoom":
          return ZoomAction;
          break;
      }
    }
  }]);

  return _class;
}();

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/story/StoryEngine.js
// module id = 342
// module chunks = 0